import { UrlConstants } from "../url.constants";
export class ApiElectricalConnectionConstants {
    static URL = UrlConstants.API_V2 + "ElectricalConnection";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalElectricalConnectionApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalElectricalConnectionApplication";
    static FUNCTION_GET_MY_AFLA_PORTAL_EC_APPLICATIONS = "GetMyAFLAPortalElectricalConnectionApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_EC_APPLICATIONS = "GetAllAFLAPortalElectricalConnectionApplications";
}
